export const ENVIRONMENTS = {
  localhost: {
    baseurl: '/sup/api/v1.0/',
  },
  dev: {
    baseurl: '/sup/api/v1.0/',
  },
  prod: {
    baseurl: 'https://sup.cpcbccr.com/sup/',
    // baseurl: 'https://9a21-14-98-12-178.ap.ngrok.io',
    // baseurl: 'http://192.168.3.171:1686/',
  },
};

export const DEPLOYED_ENVIRONMENT = 'dev';
export const BASE_PATH = '/';
